module.exports = __webpack_public_path__ + "static/media/insp_cat_2.9fb364a1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/manual/insp_cat_2.jpg
// module id = 1850
// module chunks = 0